export enum Status {
    ERRO = -1,
    SEM_INFORMACOES = 0,
    SUCESSO = 1
}